export enum OrderStatusEnum {
  'open' = 'open',
  'in-progress' = 'in-progress',
  'waiting' = 'waiting',
  'done' = 'done',
  'delivered' = 'delivered',
  'canceled' = 'canceled',
}

export enum OrderStatusEnumFormatted {
  'open' = 'Em aberto',
  'in-progress' = 'Em preparo',
  'waiting' = 'Em espera',
  'done' = 'Prontos',
  'delivered' = 'Entregues',
  'canceled' = 'Cancelados',
}
